import { DefaultComparator } from './comparators/default-comparator';
import {
  IFilterComparator,
  FilterOptions,
  FilterPassParams
} from '../filter-types';
import { convertToStringArray } from '../filter-utils';
import { FilterResultFacade } from '../filter-result-facade';
import {
  CalendarGridColumnLabel,
  CalendarGridColumnName
} from '../../../grid/types/column.types';
import { FilterHandlerBase } from './base/filter-handler-base';
import { ropValueGetter } from '../../../grid/utils/value-getters/rop-date';

export class RopFilterHandler extends FilterHandlerBase {
  private comparator: IFilterComparator<any>;

  get name(): string {
    return CalendarGridColumnName.ROP;
  }

  get label(): string {
    return CalendarGridColumnLabel.ROP;
  }
  get isInclusiveExclusive(): boolean {
    return false;
  }
  getFilterOptions(filterOptions: FilterOptions): any {
    return convertToStringArray(filterOptions.rop);
  }

  hasValidDiff(options: FilterOptions, grid: any, store: any): boolean {
    return this.getValidDiffComparator(options).hasValidDiff(grid, store);
  }

  getValidDiffComparator(options): IFilterComparator<any> {
    if (!this.comparator) {
      this.comparator = new DefaultComparator();
    }
    this.comparator.applyFilterOptions(this.getFilterOptions(options));
    return this.comparator;
  }

  doFilterPass(params: FilterPassParams, result: FilterResultFacade) {
    const isRopFilter = params.filters[this.name];
    const { id: dealId } = params.deal;
    const ropValue = ropValueGetter({
      data: params.deal
    });

    const isRopFilterPassed =
      isRopFilter !== null &&
      ((isRopFilter.model.value === 'Yes' && ropValue) ||
        (!ropValue && isRopFilter.model.value === 'No'))
        ? true
        : false;

    result.applyDealFilerResult(dealId, this.name, isRopFilterPassed);

    return isRopFilterPassed;
  }
}
